//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DisableSaveOnSectionChange: FeatureFlag = {"Id":"DisableSaveOnSectionChange","Label":"(Performance) Disable save on section change ","Impact":"Normally, on changing to a new page of a submission, the current page is saved to the backend. When this is enabled, this save is skipped.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
